export const makeValidNumber = (value) => {
    let newValue = null
    if(value === 0) return 0
    if(value){
        let number = value.toString().replace(/\s/g, '');
        newValue = +(number.replace(/,/g, '.'))
    }
    return newValue
};
